import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServicesAutomationDetails} from './citizens-services-automation-details.model';
import * as CitizensServicesAutomationDetailsActions from './citizens-services-automation-details.actions';

export const citizensServicesAutomationDetailsesFeatureKey = 'citizensServicesAutomationDetailses';

export interface State extends EntityState<CitizensServicesAutomationDetails> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesAutomationDetails> = createEntityAdapter<CitizensServicesAutomationDetails>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesAutomationDetailsActions.addCitizensServicesAutomationDetails,
    (state, action) => adapter.addOne(action.citizensServicesAutomationDetails, state)
  ),
  on(CitizensServicesAutomationDetailsActions.upsertCitizensServicesAutomationDetails,
    (state, action) => adapter.upsertOne(action.citizensServicesAutomationDetails, state)
  ),
  on(CitizensServicesAutomationDetailsActions.addCitizensServicesAutomationDetailss,
    (state, action) => adapter.addMany(action.citizensServicesAutomationDetailss, state)
  ),
  on(CitizensServicesAutomationDetailsActions.upsertCitizensServicesAutomationDetailss,
    (state, action) => adapter.upsertMany(action.citizensServicesAutomationDetailss, state)
  ),
  on(CitizensServicesAutomationDetailsActions.updateCitizensServicesAutomationDetails,
    (state, action) => adapter.updateOne(action.citizensServicesAutomationDetails, state)
  ),
  on(CitizensServicesAutomationDetailsActions.updateCitizensServicesAutomationDetailss,
    (state, action) => adapter.updateMany(action.citizensServicesAutomationDetailss, state)
  ),
  on(CitizensServicesAutomationDetailsActions.deleteCitizensServicesAutomationDetails,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesAutomationDetailsActions.deleteCitizensServicesAutomationDetailss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesAutomationDetailsActions.loadCitizensServicesAutomationDetailss,
    (state, action) => adapter.setAll(action.citizensServicesAutomationDetailss, state)
  ),
  on(CitizensServicesAutomationDetailsActions.clearCitizensServicesAutomationDetailss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
